export const PASS_TEST_PATH = "/my-tests/:id";
